import mitt from 'mitt';

// Create and export the EventBus instance
export const EventBus = mitt();